import { useId } from 'react'

const couponPolygon = "19.878 523 25.13 514.551 30.382 523 35.625 514.551 40.859 523 46.102 514.551 51.345 523 56.589 514.551 61.832 523 67.083 514.551 72.335 523 77.587 514.551 82.839 523 88.09 514.551 93.333 523 98.585 514.551 103.828 523 109.071 514.551 114.323 523 119.566 514.551 124.826 523 130.078 514.551 135.33 523 140.582 514.551 145.833 523 151.076 514.551 156.328 523 161.58 514.551 166.84 523 172.092 514.551 177.344 523 182.595 514.551 187.847 523 193.099 514.551 198.359 523 203.611 514.551 208.863 523 214.123 514.551 219.375 523 224.635 514.551 229.887 523 235.148 514.551 240.399 523 245.66 514.551 250.911 523 256.172 514.551 261.432 523 266.684 514.551 271.944 523 277.205 514.551 282.457 523 287.708 514.551 292.96 523 298.212 514.551 303.472 523 308.724 514.551 313.984 523 319.245 514.551 324.505 523 329.766 514.551 335.026 523 340.295 514.551 345.556 523 350.816 514.551 356.076 523 361.337 514.551 366.606 523 371.875 514.551 375 519.552 375 6.126 371.172 0 365.911 8.449 360.642 0 355.382 8.449 350.122 0 344.861 8.449 339.601 0 334.332 8.449 329.08 0 323.811 8.449 318.559 0 313.299 8.449 308.047 0 302.786 8.449 297.526 0 292.283 8.449 287.031 0 281.771 8.449 276.51 0 271.25 8.449 265.998 0 260.738 8.449 255.486 0 250.226 8.449 244.965 0 239.714 8.449 234.462 0 229.201 8.449 223.941 0 218.689 8.449 213.438 0 208.186 8.449 202.925 0 197.674 8.449 192.422 0 187.17 8.449 181.918 0 176.658 8.449 171.406 0 166.155 8.449 160.903 0 155.651 8.449 150.399 0 145.156 8.449 139.905 0 134.644 8.449 129.392 0 124.141 8.449 118.889 0 113.646 8.449 108.394 0 103.151 8.449 97.908 0 92.656 8.449 87.405 0 82.153 8.449 76.901 0 71.649 8.449 66.406 0 61.163 8.449 55.92 0 50.677 8.449 45.434 0 40.191 8.449 34.948 0 29.696 8.449 24.444 0 19.193 8.449 13.941 0 8.689 8.449 3.438 0 0 5.532 0 521.177 4.123 514.551 9.375 523 14.627 514.551 19.878 523"
const eventPath = "M 1 0 L 155.542 0 C 163.064 9.318 174.58 15.277 187.487 15.277 C 200.394 15.277 211.91 9.318 219.432 0 L 374 0 C 374.552 0 375 0.448 375 1 L 375 522 C 375 522.552 374.552 523 374 523 L 1 523 C 0.448 523 0 522.552 0 522 L 0 1 C 0 0.448 0.448 0 1 0 Z"
const boardingPath = "M 375 130.612 C 371.61 130.708 368.891 133.487 368.891 136.9 C 368.891 140.313 371.61 143.092 375 143.188 L 375 513 C 375 518.523 370.523 523 365 523 L 10 523 C 4.477 523 0 518.523 0 513 L 0 142.822 C 0.024 142.822 0.049 142.822 0.073 142.822 C 3.547 142.822 6.364 140.005 6.364 136.531 C 6.364 133.057 3.547 130.24 0.073 130.24 C 0.049 130.24 0.024 130.24 0 130.24 L 0 10 C 0 4.477 4.477 0 10 0 L 365 0 C 370.523 0 375 4.477 375 10 Z M 0 487 C 0 487 0 487 0 487 Z"

const ApplePreviewShape = ({ applePassType, id }) => {
  switch (applePassType) {
    case "coupon":
      return <polygon id={id} points={couponPolygon} />
    case "eventTicket":
      return <path id={id} d={eventPath} />
    case "boardingPass":
      return <path id={id} d={boardingPath} />
    case "generic":
    case "storeCard":
    default:
      return <rect id={id} width="375" height="523" rx="10" ry="10" />
  }
}

const outlineStyle = {
  stroke: 'var(--cardBorderColour, rgba(0, 0, 0, 0.28))',
  strokeWidth: 1,
  fill: 'none',
  pointerEvents: 'none',
  vectorEffect: 'non-scaling-stroke'
}

const ApplePreviewImage = ({ template, src, alt, style = {}, className = "" }) => {
  const rawId = useId().replace(/:/g, "")
  const shapeId = `apple-preview-shape-${rawId}`
  const clipPathId = `apple-preview-clip-${rawId}`

  return (
    <svg
      viewBox="0 0 375 523"
      className={className}
      style={{ display: 'block', width: '100%', height: 'auto', background: 'none', ...style }}
      role="img"
      aria-label={alt}
    >
      <defs>
        <ApplePreviewShape applePassType={template?.apple_pass_type} id={shapeId} />
        <clipPath id={clipPathId}>
          <use href={`#${shapeId}`} />
        </clipPath>
      </defs>
      <image
        href={src}
        width="375"
        height="523"
        preserveAspectRatio="xMidYMid slice"
        clipPath={`url(#${clipPathId})`}
      />
      <use href={`#${shapeId}`} style={outlineStyle} />
    </svg>
  )
}

export {
  ApplePreviewImage
}
